const ACRONYMS: Record<string, string> = {
  ui: 'UI',
  ux: 'UX',
}

/**
 * Converts snake_case or kebab-case strings to Title Case, preserving known
 * acronyms (e.g. "ui_elements" → "UI Elements").
 */
export const formatLabel = (value: string): string =>
  value
    .replace(/[_-]/g, ' ')
    .split(' ')
    .map((word) => ACRONYMS[word.toLowerCase()] ?? word.replace(/^\w/, (c) => c.toUpperCase()))
    .join(' ')
